var _defs, _rect, _rect2, _rect3, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.21 17.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3ba2f;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.53,
    y: 8.49,
    width: 3.05,
    height: 3.05,
    transform: "translate(7.08 -0.26) rotate(45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.48,
    y: 8.49,
    width: 3.05,
    height: 3.05,
    transform: "translate(9.12 -5.17) rotate(45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.43,
    y: 8.49,
    width: 3.05,
    height: 3.05,
    transform: "translate(11.15 -10.09) rotate(45)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.56 12.47 9.1 17.93 3.64 12.47 5.8 10.31 9.1 13.62 12.41 10.31 14.56 12.47"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.56 5.46 9.1 0 3.64 5.46 5.8 7.61 9.1 4.31 12.41 7.61 14.56 5.46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/BSC.00e07ca5efe58f142cfdaee65f111637.svg";
export { ForwardRef as ReactComponent };